module.exports = __webpack_public_path__ + "static/media/RoWRB.29ffce30.png";